import { WidgetsParcelsMain } from '@/widgets/parcels';

export const PagesParcelsMain = () => <WidgetsParcelsMain />;
